module.exports = __webpack_public_path__ + "static/img/purpleLogo.59c838ec.png";